import { Component } from '@angular/core';
import { TRANSLATIONS_IMPORTS } from '../../../shared/shared-exports/translation.exports';
import { LoaderService } from '../../../services/loader-service';

@Component({
  selector: 'app-enrolled-institutions',
  imports: [...TRANSLATIONS_IMPORTS],
  templateUrl: './enrolled-institutions.html',
  styleUrl: './enrolled-institutions.scss',
})
export class EnrolledInstitutions {
  constructor(public readonly loaderService: LoaderService){}
  enrolledInstitutions = [
    { imagePath: 'assets/logo/ega-logo.png' },
    { imagePath: 'assets/logo/tcra-logo.png' },
    { imagePath: 'assets/logo/ppra-logo.png' },
    { imagePath: 'assets/logo/pdpc-logo.png' },
    { imagePath: 'assets/logo/brela-logo.png' },
    { imagePath: 'assets/logo/ucc-logo.png' },
    { imagePath: 'assets/logo/msd-logo.png' },
    { imagePath: 'assets/logo/mipango-logo.png' },
    { imagePath: 'assets/logo/mikutano-logo.png' },
  ];
}
